import { ConnectedPosition } from '@angular/cdk/overlay';
import { NgZone } from '@angular/core';

export const MULTI_SELECT_OVERLAY_PANEL_CLASS = 'sgt-multi-select-overlay-panel';

export const MULTI_SELECT_GROUPED_OVERLAY_PANEL_CLASS =
  'sgt-multi-select-grouped-overlay-panel';

export const SELECT_OVERLAY_PANEL_CLASS = 'sgt-select-overlay-panel';

export const SELECT_GROUPED_OVERLAY_PANEL_CLASS =
  'sgt-select-grouped-overlay-panel';

export const ALTURA_MAXIMA_DROPDOWN = 360;

const POSICOES_ABAIXO: ConnectedPosition[] = [
  {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
    offsetY: 4
  },
  {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top',
    offsetY: 4
  }
];

const POSICOES_ACIMA: ConnectedPosition[] = [
  {
    originX: 'start',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'bottom',
    offsetY: -4
  },
  {
    originX: 'end',
    originY: 'top',
    overlayX: 'end',
    overlayY: 'bottom',
    offsetY: -4
  }
];

export const DROPDOWN_OVERLAY_POSITIONS: ConnectedPosition[] = [
  ...POSICOES_ABAIXO,
  ...POSICOES_ACIMA
];

export function ordenarPosicoesPeloEspacoDisponivel(
  trigger: HTMLElement,
  alturaDesejada: number
): ConnectedPosition[] {
  const limite = encontrarContainerLimitante(trigger);
  const triggerRect = trigger.getBoundingClientRect();

  const limiteInferior = limite
    ? Math.min(limite.getBoundingClientRect().bottom, window.innerHeight)
    : window.innerHeight;
  const limiteSuperior = limite
    ? Math.max(limite.getBoundingClientRect().top, 0)
    : 0;

  const espacoAbaixo = limiteInferior - triggerRect.bottom;
  const espacoAcima = triggerRect.top - limiteSuperior;

  const abreParaCima =
    espacoAbaixo < alturaDesejada && espacoAcima > espacoAbaixo;

  return abreParaCima
    ? [...POSICOES_ACIMA, ...POSICOES_ABAIXO]
    : [...POSICOES_ABAIXO, ...POSICOES_ACIMA];
}

function encontrarContainerLimitante(elemento: HTMLElement): HTMLElement | null {
  let atual = elemento.parentElement;

  while (atual && atual !== document.body) {
    const estilo = getComputedStyle(atual);
    const recorta = [estilo.overflowY, estilo.overflow].some(
      (valor) => valor === 'auto' || valor === 'scroll' || valor === 'hidden'
    );

    if (recorta) {
      return atual;
    }
    atual = atual.parentElement;
  }

  return null;
}

export function fecharAoRolarAncestral(
  origem: HTMLElement,
  classeDoPainel: string,
  ngZone: NgZone,
  aoRolar: () => void
): () => void {
  const listener = (event: Event): void => {
    const alvo = event.target;

    if (alvo instanceof Node && origem.contains(alvo)) {
      return;
    }

    const elemento = alvo instanceof Element ? alvo : null;

    if (elemento?.closest(`.${classeDoPainel}`)) {
      return;
    }

    ngZone.run(aoRolar);
  };

  window.addEventListener('scroll', listener, true);

  return () => window.removeEventListener('scroll', listener, true);
}
